"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPLY_DISCOUNT_RESPONSE_EXAMPLE = void 0;
exports.APPLY_DISCOUNT_RESPONSE_EXAMPLE = {
    discountAmount: 5000,
    requiresApproval: false,
    notificationSent: false,
};
//# sourceMappingURL=financial-discount.response.js.map